import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,LoadingController,AlertController} from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import {AppLoanRequirementPage} from '../app-loan-requirement/app-loan-requirement';



/**
 * Generated class for the AppPersonalInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-personal-info',
  templateUrl: 'app-personal-info.html',
})
export class AppPersonalInfoPage {
  model:any={}
  modelRequest:any={}
  fetchData:any = {};
  fetchApplicantData:any = {}
  fetchApplicantDataArray:any=[];
  fetchPincodeData:any = {}
  modelLead:any={}
  latestNavParams:any={}
  errorDisplay:any={};
  cities:any=[];
  cityFlag:any=false;
  errorSingleDisplay:any={};
  occup_name:any="";
  dateC:any="";
  year:any="";
  constructor(private fb: FormBuilder,private cp: CommonProvider,
  public alertCtrl: AlertController, public loadingCtrl: LoadingController,public navCtrl: NavController, public navParams: NavParams,
    private fv : GenericFormValidationProvider) {
    this.model.lead={};
    this.modelRequest.lead={};
    this.fetchPincodeData.ibhfl_city={}
    
     // this.modelRequest.applicants[0]={}
    
  }

  ionViewDidLoad() {
    const d = new Date();
    this.year = d.getFullYear()-18;
    this.dateC = this.year+'-01'+'-01'; 
    ////console.log('ionViewDidLoad AppPersonalInfoPage',JSON.parse(this.navParams.data));
    localStorage.setItem("loantype",JSON.parse(this.navParams.data).Payload.lead.ibhfl_purposeproduct)
    this.model.lead.ibhfl_residentialstatusid="RI";
    this.model.lead.ibhfl_Occupationid="28"
    console.log("leadid",JSON.parse(this.navParams.data).Payload.lead.leadid)
    this.veiwLead(JSON.parse(this.navParams.data).Payload.lead.leadid)

  }
  resetDataOccupation(occuptionId){
    
    this.model.lead.ibhfl_Occupationid=occuptionId;
     if(this.model.lead.ibhfl_Occupationid==='28'){
            this.occup_name = "Salaried"
          }else if(this.model.lead.ibhfl_Occupationid==='29'){
            this.occup_name = "Self-employed"
          }else{
            this.occup_name = "Professional"
          }
          console.log(this.occup_name);
    if(occuptionId=="28"){
      this.model.lead.ibhfl_applicanttype="303710000"
    }
  }
  veiwLead(leadid,create?:any){
    let request:any = {};
    request.leadId=leadid

      let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
      this.cp.viewLeadById(loading,request).then((res:any)=>{
         loading.dismiss();
         try{
            console.log("viewleadby id",JSON.parse(res));
            this.latestNavParams=res;
            this.fetchData = JSON.parse(res).Payload.lead
            if(create){
            console.log("viewleadby create",create);
              this.model.lead={};
              this.model.applicants=this.fetchData.applicants;
              console.log("lead applicant s",this.fetchData.applicants);
              this.fetchApplicantDataArray= this.fetchData.applicants.filter((res:any)=>{
                return res.ibhfl_applicantrole=="303710000" && res.ibhfl_firstname!=""
              }) ;

              if(this.fetchApplicantDataArray.length>0){
                this.fetchApplicantData=this.fetchApplicantDataArray[0]
              }
              // console.log("lead applicant",this.fetchApplicantData);
              this.model.lead.leadid=leadid;
              this.model.lead.ibhfl_applicanttype=this.fetchApplicantData.ibhfl_applicanttype;
              this.model.lead.ibhfl_residentialstatusid=this.fetchApplicantData.ibhfl_residentialstatusid?this.fetchApplicantData.ibhfl_residentialstatusid:"RI";
              this.model.lead.ibhfl_Occupationid=this.fetchApplicantData.ibhfl_Occupationid?this.fetchApplicantData.ibhfl_Occupationid:"28"
              this.model.lead.ibhfl_Occupationid_name=this.fetchApplicantData.ibhfl_Occupationid_name?this.fetchApplicantData.ibhfl_Occupationid_name:"Salaried"
              this.model.lead.firstname=this.fetchApplicantData.ibhfl_firstname
              this.model.lead.middlename=this.fetchApplicantData.ibhfl_middlename
              this.model.lead.lastname=this.fetchApplicantData.ibhfl_lastname
              this.model.lead.ibhfl_entityname=this.model.applicants[0].ibhfl_entityname
              this.model.lead.ibhfl_genderid=this.fetchApplicantData.ibhfl_genderid?this.fetchApplicantData.ibhfl_genderid:"M"
              this.model.lead.ibhfl_dateofbirth=this.fetchApplicantData.ibhfl_dateofbirth
              this.model.lead.pincode=this.fetchApplicantData.pincode
              this.model.lead.city_name=this.fetchApplicantData.city_name
              this.model.lead.state=this.fetchApplicantData.state
              this.model.lead.ibhfl_stageid="1"
              this.modelLead=this.model.lead 
              this.updateData(this.fetchData)
            }else{
              this.model.lead={};
              this.model.applicants=this.fetchData.applicants;
              console.log("lead applicant s",this.fetchData.applicants);
              this.fetchApplicantDataArray= this.fetchData.applicants.filter((res:any)=>{
                return res.ibhfl_applicantrole=="303710000" && res.ibhfl_firstname!=""
              }) ;

              if(this.fetchApplicantDataArray.length>0){
                this.fetchApplicantData=this.fetchApplicantDataArray[0]
              }
              // console.log("lead applicant",this.fetchApplicantData);
              this.model.lead.leadid=leadid;
              this.model.lead.ibhfl_applicanttype=this.fetchApplicantData.ibhfl_applicanttype;
              this.model.lead.ibhfl_residentialstatusid=this.fetchApplicantData.ibhfl_residentialstatusid?this.fetchApplicantData.ibhfl_residentialstatusid:"RI";
              this.model.lead.ibhfl_Occupationid=this.fetchApplicantData.ibhfl_Occupationid?this.fetchApplicantData.ibhfl_Occupationid:"28"
              this.model.lead.ibhfl_Occupationid_name=this.fetchApplicantData.ibhfl_Occupationid_name?this.fetchApplicantData.ibhfl_Occupationid_name:"Salaried"
              this.model.lead.firstname=this.fetchApplicantData.ibhfl_firstname
              this.model.lead.middlename=this.fetchApplicantData.ibhfl_middlename
              this.model.lead.lastname=this.fetchApplicantData.ibhfl_lastname
              this.model.lead.ibhfl_entityname=this.model.applicants[0].ibhfl_entityname
              this.model.lead.ibhfl_genderid=this.fetchApplicantData.ibhfl_genderid?this.fetchApplicantData.ibhfl_genderid:"M"
              this.model.lead.ibhfl_dateofbirth=this.fetchApplicantData.ibhfl_dateofbirth
              this.model.lead.pincode=this.fetchApplicantData.pincode
              this.model.lead.city_name=this.fetchApplicantData.city_name
              this.model.lead.state=this.fetchApplicantData.state
              this.model.lead.ibhfl_stageid="1"
              this.modelLead=this.model.lead 
              this.pincodeUpdate(); 
            }
            
            
         }catch(e){
          ////console.log(e)
         }
       })
  }
  pincodeUpdate(){
    if(this.model.lead.pincode ){
    

       
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    let request:any={}
    request.pincodeID = this.model.lead.pincode     
    this.cp.getCityByPincode(loading,request).then((res:any)=>{
      loading.dismiss();

       ////console.log(JSON.parse(res),"res data");
       if(JSON.parse(res).Payload.ibhfl_pincodes.length>0){


       this.model.lead.city_name = JSON.parse(res).Payload.ibhfl_pincodes?JSON.parse(res).Payload.ibhfl_pincodes[0].ibhfl_city.ibhfl_name:"";
       this.fetchPincodeData = JSON.parse(res).Payload.ibhfl_pincodes[0];

       }
    })
  
    }


    
  }

createApplicantByLeadID(lead){
       
     let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
          // let this.occup_name :any = ""
          if(this.model.lead.ibhfl_Occupationid==='28'){
            this.occup_name = "Salaried"
          }else if(this.model.lead.ibhfl_Occupationid==='29'){
            this.occup_name = "Self-employed"
          }else{
            this.occup_name = "Professional"
          }
          let request : any={
              "lead": {
                  "leadid": lead,
                   
              },
              "applicants": [
                  {
                      "ibhfl_applicantrole": "303710000",
                      "ibhfl_residentialstatusid": this.model.lead.ibhfl_residentialstatusid,
                      "ibhfl_applicanttype": "303710000",
                      "ibhfl_Occupationid": this.model.lead.ibhfl_Occupationid,

                      "ibhfl_Occupationid_name": this.occup_name,

                      "ibhfl_firstname": this.model.lead.firstname,

                      "ibhfl_middlename": this.model.lead.middlename,
                      "ibhfl_lastname": this.model.lead.lastname,
                      "ibhfl_genderid": this.model.lead.ibhfl_genderid,
                      "ibhfl_dateofbirth": this.model.lead.ibhfl_dateofbirth,
                      "ibhfl_mobilephone1": this.model.lead.mobilephone1?this.model.lead.mobilephone1:localStorage.getItem('mobile').slice(-10),
                      "pincode": this.model.lead.pincode,
                      "city": this.fetchPincodeData.ibhfl_city?this.fetchPincodeData.ibhfl_city.ibhfl_citycode.toString():"",
                      "state": this.fetchPincodeData.ibhfl_state?this.fetchPincodeData.ibhfl_state.ibhfl_statecode.toString():"",



                      "addresses": [
                          {
                              "addressType": "CURRES"
                          },
                          {
                              "addressType": "PERRES"
                          },
                          {
                              "addressType": "OFFICE"
                          }
                      ]
                  }
              ]
          }
       
      this.cp.createLead(loading,request).then((res:any)=>{
         loading.dismiss();
         try{
          
          if(JSON.parse(res).Error && JSON.parse(res).Error.ErrorCode==400){

          }else{
             
            this.veiwLead(JSON.parse(res).Payload.lead.leadid,true)
             
          }

         }catch(e){
           ////console.log(e)
         } 
           
      })
  }
  showAlert(msg,title) {
    const alert = this.alertCtrl.create({
      title:title,
      subTitle: msg,
      buttons: [{
          text: 'Ok',
          handler: data => {
            this.pincodeUpdate()
          }
        }]
    });
    alert.present();
  }
  checkValidation(keyname?:any){
   if(Object.keys(this.errorDisplay).length>0){
    this.errorSingleDisplay = this.fv.checkValidationFormAllControls(document.forms['app-personal'],true,[]);
    if(Object.keys(this.errorSingleDisplay).length>0){
     var index = Object.keys(this.errorSingleDisplay).findIndex((res:any)=>{
        return res==keyname
      })
        console.log(index);

      if(index==-1){
        delete this.errorDisplay[keyname];
        if(this.errorDisplay.length>0 && this.errorDisplay.length<=1)
        {
          this.errorDisplay.valid=false
        }
        console.log(this.errorDisplay);
      }
    }
    
   }
   
  }
  updateInfo(){
     
   this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms['app-personal'],true,[]);
     
   if(this.errorDisplay.valid){
     return false;
   }else{

    if(!this.model.lead.city_name){
      this.showAlert("Please select city","Error")
      return false;
    }
    if(this.model.applicants.length==0){
      this.createApplicantByLeadID(this.model.lead.leadid)
    }else{
       this.updateData(this.fetchData)
    }
   }
    
   
    
  }
  updateData(fetchdata){

    this.fetchData=fetchdata;
    // let this.occup_name :any = ""
    if(this.model.lead.ibhfl_Occupationid==='28'){
      this.occup_name = "Salaried"
    }else if(this.model.lead.ibhfl_Occupationid==='29'){
      this.occup_name = "Self-employed"
    }else{
      this.occup_name = "Professional"
    }
    this.fetchData.applicants=this.fetchData.applicants.filter((res:any)=>{
      return res.ibhfl_applicantrole=="303710000" && res.ibhfl_firstname!="" 
    })
    this.modelLead.ibhfl_Occupationid_name=this.occup_name
    console.log("expecting data",this.modelLead)
    // return false

    this.modelRequest.applicants=[{}];
    this.modelRequest.lead = this.modelLead;
    this.modelRequest.lead.ibhfl_Occupationid = this.modelLead.ibhfl_Occupationid.toString();
    this.modelRequest.applicants[0].ibhfl_applicantrole = this.fetchData.applicants[0].ibhfl_applicantrole?this.fetchData.applicants[0].ibhfl_applicantrole.toString():"303710000"
    this.modelRequest.applicants[0].ibhfl_residentialstatusid = this.fetchData.applicants[0].ibhfl_residentialstatusid?this.fetchData.applicants[0].ibhfl_residentialstatusid:this.model.lead.ibhfl_residentialstatusid
    this.modelRequest.applicants[0].ibhfl_applicanttype= this.fetchData.applicants[0].ibhfl_applicanttype?this.fetchData.applicants[0].ibhfl_applicanttype.toString():"303710000"
    this.modelRequest.applicants[0].ibhfl_Occupationid= this.model.lead.ibhfl_Occupationid.toString()
    this.modelRequest.applicants[0].ibhfl_Occupationid_name=this.occup_name
    this.modelRequest.applicants[0].ibhfl_firstname= this.fetchData.applicants[0].ibhfl_firstname?this.fetchData.applicants[0].ibhfl_firstname:this.model.lead.firstname

    this.modelRequest.applicants[0].ibhfl_middlename= this.fetchData.applicants[0].ibhfl_middlename?this.fetchData.applicants[0].ibhfl_middlename:this.model.lead.middlename
    
    this.modelRequest.applicants[0].ibhfl_lastname= this.fetchData.applicants[0].ibhfl_lastname?this.fetchData.applicants[0].ibhfl_lastname:this.model.lead.lastname
    this.modelRequest.applicants[0].ibhfl_genderid= this.fetchData.applicants[0].ibhfl_genderid?this.fetchData.applicants[0].ibhfl_genderid:this.model.lead.ibhfl_genderid
    this.modelRequest.applicants[0].ibhfl_dateofbirth= this.model.lead.ibhfl_dateofbirth
    this.modelRequest.applicants[0].preferredAddressType= this.fetchData.applicants[0].preferredAddressType
    this.modelRequest.applicants[0].ibhfl_mobilephone1= this.fetchData.applicants[0].ibhfl_mobilephone1
    this.modelRequest.applicants[0].applicantid= this.fetchData.applicants[0].applicantid.toString()
    
    
    // this.modelRequest.applicants[0].addresses= this.fetchData.applicants[0].addresses
    this.fetchData.applicants[0].addresses.forEach((getRes:any)=>{
      if(getRes.addressType=="CURRES"){
        let objAddCurr:any = {}
        objAddCurr.addressType = getRes.addressType
        objAddCurr.addressid  = getRes.addressid
        objAddCurr.pincode  = getRes.pincode ?getRes.pincode:this.model.lead.pincode
        objAddCurr.city   = getRes.city ?getRes.city:this.fetchPincodeData.ibhfl_city.ibhfl_citycode.toString()
        objAddCurr.state  = getRes.state ?getRes.state:this.fetchPincodeData.ibhfl_state.ibhfl_statecode.toString()
        // objAddCurr.country  = getRes.country 

        this.modelRequest.applicants[0].addresses=[objAddCurr]
      }
    })
    if(this.model.lead.pincode){
      this.modelRequest.applicants[0].pincode= this.model.lead.pincode?this.model.lead.pincode:""
      this.modelRequest.applicants[0].city= this.fetchPincodeData.ibhfl_city.ibhfl_citycode?this.fetchPincodeData.ibhfl_city.ibhfl_citycode.toString():""
      this.modelRequest.applicants[0].state=this.fetchPincodeData.ibhfl_state.ibhfl_statecode?this.fetchPincodeData.ibhfl_state.ibhfl_statecode.toString():""
      this.modelRequest.lead.city= this.fetchPincodeData.ibhfl_city.ibhfl_citycode.toString()
      this.modelRequest.lead.state=this.fetchPincodeData.ibhfl_state.ibhfl_statecode.toString()
    }else{
      this.modelRequest.applicants[0].city= this.fetchPincodeData.ibhfl_city.ibhfl_citycode
    }
    
    this.modelRequest.lead.ibhfl_applicanttype=this.fetchData.applicants[0].ibhfl_applicanttype.toString()
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    let request:any={}
     
    console.log("city goted",this.model,this.modelRequest);
    // loading.dismiss();
    //  return false
    try{
       this.cp.updateLead(loading,this.modelRequest).then((res:any)=>{
      loading.dismiss();
       
      let responce :any ={}
       console.log(JSON.parse(res),"update lead");
       if(JSON.parse(res).Payload){
        
        this.navCtrl.push(AppLoanRequirementPage,this.latestNavParams)
       }else{

       }

       
       
    })
    }catch(e){
      console.log(e)
    }
    
  }
  resetData(citizanShip){
    ////console.log(citizanShip)
    if(citizanShip=='RI'){

    }else{
      this.model.lead.ibhfl_Occupationid="28"
      this.model.lead.account_type=''
      this.model.lead.pincode="";
      this.model.lead.city_name="";
    }
  }
  addCity(objCity){
    this.cityFlag=false;
    this.model.lead.city_name = objCity.ibhfl_name;
    if(this.model.lead.pincode){
      this.modelRequest.lead.city=objCity.ibhfl_citycode
    }
    // this.model.lead.ibhfl_PropertyCity = objCity.ibhfl_citycode;
  }


  addFocus(e){
    
  }
  search(e){
     if(this.model.lead.city_name && this.model.lead.city_name.length%3==0){
          let loading = this.loadingCtrl.create({
               content: 'Please wait...'
              });
              loading.present();
              let request:any={}
              request.nri_cityname = this.model.lead.city_name     
              this.cp.getNriZipcode(loading,request).then((res:any)=>{
                loading.dismiss();

                 this.cities=JSON.parse(res).Payload.ibhfl_cities
                 console.log("cities",this.cities);
                 if(this.cities.length>0){
                  this.cityFlag=true
                 }else{
                  this.cityFlag=false
                 }
              })
      
            
      }
  }
  cityMaster(){
     
  }
   
  removeFocus(e){
    //console.log(e)
  }
   


  getNriZipcode(){

    if(this.model.lead.city_name && this.model.lead.city_name.length%3==0){
          let loading = this.loadingCtrl.create({
               content: 'Please wait...'
              });
              loading.present();
              let request:any={}
              request.nri_cityname = this.model.lead.city_name     
              this.cp.getNriZipcode(loading,request).then((res:any)=>{
                loading.dismiss();

                 console.log(JSON.parse(res),"res data");
                 this.cities=JSON.parse(res).Payload.ibhfl_cities
              })
      
            
      }
    }   
    
}



// WEBPACK FOOTER //
// ./src/pages/app-personal-info/app-personal-info.ts